import { EIso639One } from "@devowl-wp/iso-codes";
var ESupportTicketAllowedAttachmentTypes;
(function(ESupportTicketAllowedAttachmentTypes) {
    ESupportTicketAllowedAttachmentTypes["Jpeg"] = "image/jpeg";
    ESupportTicketAllowedAttachmentTypes["Png"] = "image/png";
    ESupportTicketAllowedAttachmentTypes["Gif"] = "image/gif";
    ESupportTicketAllowedAttachmentTypes["Webp"] = "image/webp";
    ESupportTicketAllowedAttachmentTypes["Pdf"] = "application/pdf";
    ESupportTicketAllowedAttachmentTypes["Zip"] = "application/zip";
    ESupportTicketAllowedAttachmentTypes["XZip"] = "application/x-zip";
    ESupportTicketAllowedAttachmentTypes["XZipCompressed"] = "application/x-zip-compressed";
    ESupportTicketAllowedAttachmentTypes["Mp4"] = "video/mp4";
    ESupportTicketAllowedAttachmentTypes["Mpeg"] = "video/mpeg";
    ESupportTicketAllowedAttachmentTypes["Ogg"] = "video/ogg";
    ESupportTicketAllowedAttachmentTypes["Webm"] = "video/webm";
    ESupportTicketAllowedAttachmentTypes["XMsVideo"] = "video/x-msvideo";
})(ESupportTicketAllowedAttachmentTypes || (ESupportTicketAllowedAttachmentTypes = {}));
var ESupportTicketProduct;
(function(ESupportTicketProduct) {
    ESupportTicketProduct["RealCookieBanner"] = "rcb";
    ESupportTicketProduct["RealMediaLibrary"] = "rml";
    ESupportTicketProduct["RealPhysicalMedia"] = "rpm";
    ESupportTicketProduct["RealCategoryManagement"] = "rcm";
    ESupportTicketProduct["RealThumbnailGenerator"] = "rtg";
    ESupportTicketProduct["Other"] = "other";
})(ESupportTicketProduct || (ESupportTicketProduct = {}));
var ESupportTicketQuestionType;
/**
 * @usedBy Entities
 */ (function(ESupportTicketQuestionType) {
    ESupportTicketQuestionType["PreSaleQuestion"] = "pre-sale";
    /**
     * @deprecated This option is no longer used, keep for backwards compatibility in database.
     */ ESupportTicketQuestionType["SetupOfProduct"] = "setup";
    ESupportTicketQuestionType["ProblemWithProduct"] = "product-issue";
    ESupportTicketQuestionType["ProblemWithLicenseOrAccount"] = "account-issue";
    ESupportTicketQuestionType["FeatureRequest"] = "feature-request";
    ESupportTicketQuestionType["RequestCustomOffer"] = "request-custom-offer";
})(ESupportTicketQuestionType || (ESupportTicketQuestionType = {}));
var ESupportLanguageOfSupport;
/**
 * @usedBy Entities
 */ (function(ESupportLanguageOfSupport) {
    ESupportLanguageOfSupport[ESupportLanguageOfSupport["English"] = EIso639One.English] = "English";
    ESupportLanguageOfSupport[ESupportLanguageOfSupport["German"] = EIso639One.German] = "German";
})(ESupportLanguageOfSupport || (ESupportLanguageOfSupport = {}));
var ESupportTicketSupportStatus;
(function(ESupportTicketSupportStatus) {
    ESupportTicketSupportStatus["Valid"] = "valid";
    ESupportTicketSupportStatus["Expired"] = "EXPIRED";
    ESupportTicketSupportStatus["Unknown"] = "unknown";
})(ESupportTicketSupportStatus || (ESupportTicketSupportStatus = {}));
export { ESupportLanguageOfSupport, ESupportTicketAllowedAttachmentTypes, ESupportTicketProduct, ESupportTicketQuestionType, ESupportTicketSupportStatus };
